<script lang="ts" setup>
  import { computed, ref, PropType } from 'vue'
  import { getColorForString, getInitials } from '@/lib/utils'
  import type { CustomerOrganisationUser as User } from '@/types/generated'
  import SkeletonLoader from '@/components/skeleton/SkeletonLoader.vue'

  const props = defineProps({
    user: {
      type: Object as PropType<User>,
      required: true
    },
    size: {
      type: String,
      default: '38px'
    }
  })

  const isLoading = ref(true)
  const initials = computed(() => {
    return getInitials(props.user.first_name + ' ' + props.user.last_name)
  })

  const avatarColor = computed(() => {
    return `bg-${getColorForString(props.user.first_name + ' ' + props.user.last_name)}-600`
  })

  const onImageLoad = () => {
    isLoading.value = false
  }
</script>

<template>
  <span
    class="relative inline-flex shrink-0 items-center justify-center rounded-full"
    :style="{ width: size, height: size }"
    :class="user?.avatar ? 'bg-transparent' : avatarColor"
  >
    <SkeletonLoader
      v-if="user?.avatar && isLoading"
      type="circle"
      :width="size"
      :height="size"
    />
    <img
      v-if="user?.avatar"
      :src="user.avatar"
      class="rounded-full object-cover"
      :style="{ width: size, height: size }"
      @load="onImageLoad"
    />
    <span
      v-else
      class="text-sm font-medium leading-none text-white"
    >
      {{ initials }}
    </span>
  </span>
</template>
